module.exports = __webpack_public_path__ + "img/DNADamage-NPC_GSE200310.7a2fb2bf.png";